import script from "./DocumentSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentSelector.vue?vue&type=script&setup=true&lang=js"

import "./DocumentSelector.vue?vue&type=style&index=0&id=78bbdee0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78bbdee0"]])

export default __exports__